import React from 'react'
import {
  Create,
  TextInput,
  SelectInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  FormDataConsumer,
  FormTab,
  TabbedForm,
  CardActions,
} from 'react-admin'
import Button from '@material-ui/core/Button'

import useFetch from '@lib/useFetch'
import { DEFAULT_API_ADMIN } from '@/constants'
import { getChainId } from '@lib'
import { withStyles } from '@material-ui/core/styles'

const formIteratorRef = React.createRef()

const MoneyProductCreateActions = props => {
  const customAction = () => {
    const defaultValueInputRef = document['getElementById'](
      'defaultValueInput',
    ) as HTMLInputElement
    if (!defaultValueInputRef) {
      return
    }
    const defaultValue = defaultValueInputRef.value

    const refs = {}
    refs['formIteratorRef'] = formIteratorRef

    props.opts.forEach(({ id, name }) =>
      refs['formIteratorRef'].current.props.fields.push({
        placeId: id,
        price: defaultValue,
      }),
    )
  }

  return (
    <CardActions>
      <Button color="primary" onClick={customAction}>
        Adicionar Todos
      </Button>
    </CardActions>
  )
}

const editStyles = {
  placesInput: {
    '& p': {
      color: 'grey',
      'margin-right': '1em',
      'font-weight': 'bold',
    },
  },
}

const create = withStyles(editStyles)(({ classes, ...props }) => {
  const [{ data }] = useFetch({
    url: `${DEFAULT_API_ADMIN}/places`,
    initialState: { data: [] },
  })

  const getChoices = () =>
    data
      .filter(item => item.chainId === getChainId())
      .map(({ id, name }) => ({ id, name }))

  const validate = [required()]

  const opts = data ? getChoices() : []

  return (
    <Create
      actions={<MoneyProductCreateActions opts={opts} />}
      {...props}
      title="Cadastrar novo produto"
    >
      <TabbedForm>
        <FormTab label="Produto">
          <TextInput source="name" label="Valor" validate={validate} />
        </FormTab>
        <FormTab label="Resgate">
          <TextInput
            source="defaultValue"
            label="Valor Padrão"
            id="defaultValueInput"
          />
          <ArrayInput source="places" label="" className={classes.placesInput}>
          <FormDataConsumer>
              {({ formData: upperFormData, ...upperRest }) => {
                const disableRemove = upperFormData.places
                  ? upperFormData.places.length === 1
                  : false
                return (
                  <SimpleFormIterator
                    disableRemove={disableRemove}
                    ref={formIteratorRef}
                    {...upperRest}
                  >
                    <FormDataConsumer>
                      {({
                        formData,
                        scopedFormData,
                        getSource,
                        label,
                        ...rest
                      }) => {
                        const allPlaces = data ? getChoices() : []
                        const selectedPlacesIds = formData.places.map(
                          p => p.placeId,
                        )
                        const availablePlaces = allPlaces.filter(
                          ({ id }) =>
                            !selectedPlacesIds.includes(id) ||
                            (scopedFormData
                              ? scopedFormData.placeId === id
                              : true),
                        )

                        return (
                          <SelectInput
                            disableRemove={true}
                            source={getSource('placeId')}
                            choices={availablePlaces}
                            label="Unidade de troca"
                            {...rest}
                          />
                        )
                      }}
                    </FormDataConsumer>
                    <TextInput
                      source="price"
                      label="Valor em pontos"
                      validate={validate}
                    />
                  </SimpleFormIterator>
                )
              }}
            </FormDataConsumer>
          </ArrayInput>
        </FormTab>
      </TabbedForm>
    </Create>
  )
})

export default create